<div class="form-section">
  @if (title()) {
    <div class="form-section-header">
      @if (icon()) {
        <htx-icon class="header-icon" [icon]="icon()"></htx-icon>
      }
      <h2 class="header-title">{{ title() }}</h2>
    </div>
  }

  @if (showErrorSummary() && formGroup()) {
    <htx-error-summary-field
      [form]="formGroup()!"
      [title]="errorSummaryTitle()"
      [controlNames]="controlNames()"
      [fieldLabels]="fieldLabels()"
      [errorTypeLabels]="errorTypeLabels()"
    ></htx-error-summary-field>
  }

  <div class="form-section-content">
    <ng-content></ng-content>
  </div>
</div>
